if (!customElements.get('quantity-popover')) {
  customElements.define(
    'quantity-popover',
    class QuantityPopover extends HTMLElement {
      constructor() {
        super();
        this.mql = window.matchMedia('(min-width: 990px)');
        this.mqlTablet = window.matchMedia('(min-width: 750px)');
        this.infoButtonDesktop = this.querySelector('.quantity-popover__info-button--icon-only');
        this.infoButtonMobile = this.querySelector('.quantity-popover__info-button--icon-with-label');
        this.popoverInfo = this.querySelector('.quantity-popover__info');
        this.closeButton = this.querySelector('.button-close');
        this.eventMouseEnterHappened = false;

        if (this.closeButton) {
          this.closeButton.addEventListener('click', this.closePopover.bind(this));
        }

        if (this.popoverInfo && this.infoButtonDesktop && this.mqlTablet.matches) {
          this.popoverInfo.addEventListener('mouseleave', this.closePopover.bind(this));
        }

        if (this.infoButtonDesktop) {
          this.infoButtonDesktop.addEventListener('click', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('focusout', this.closePopover.bind(this));
        }

        if (this.infoButtonMobile) {
          this.infoButtonMobile.addEventListener('click', this.togglePopover.bind(this));
        }

        if (this.infoButtonDesktop && this.mqlTablet.matches) {
          this.infoButtonDesktop.addEventListener('mouseenter', this.togglePopover.bind(this));
          this.infoButtonDesktop.addEventListener('mouseleave', this.closePopover.bind(this));
        }
      }

      togglePopover(event) {
        event.preventDefault();
        if (event.type === 'mouseenter') {
          this.eventMouseEnterHappened = true;
        }

        if (event.type === 'click' && this.eventMouseEnterHappened) return;

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;
        const isExpanded = button.getAttribute('aria-expanded') === 'true';

        if ((this.mql.matches && !isExpanded) || event.type === 'click') {
          button.setAttribute('aria-expanded', !isExpanded);

          this.popoverInfo.toggleAttribute('hidden');

          button.classList.toggle('quantity-popover__info-button--open');

          this.infoButtonDesktop.classList.add('quantity-popover__info-button--icon-only--animation');
        }

        const isOpen = button.getAttribute('aria-expanded') === 'true';

        if (isOpen && event.type !== 'mouseenter') {
          button.focus();
          button.addEventListener('keyup', (e) => {
            if (e.key === 'Escape') {
              this.closePopover(e);
            }
          });
        }
      }

      closePopover(event) {
        event.preventDefault();
        const isButtonChild = this.infoButtonDesktop.contains(event.relatedTarget);
        const isPopoverChild = this.popoverInfo.contains(event.relatedTarget);

        const button = this.infoButtonDesktop && this.mql.matches ? this.infoButtonDesktop : this.infoButtonMobile;

        if (!isButtonChild && !isPopoverChild) {
          button.setAttribute('aria-expanded', 'false');
          button.classList.remove('quantity-popover__info-button--open');
          this.popoverInfo.setAttribute('hidden', '');
          this.infoButtonDesktop.classList.remove('quantity-popover__info-button--icon-only--animation');
        }

        this.eventMouseEnterHappened = false;
      }
    }
  );
}


// === STOCK LIMITATION FOR QUICK ORDER LIST (v6.1 - Message "Stock maximum atteint") ===
document.addEventListener('DOMContentLoaded', () => {
  const getMaxForVariant = (variantId) => {
    const row = document.querySelector(`tr[data-variant-id="${variantId}"]`);
    if (!row) return null;
    const strong = row.querySelector('.variant-item__stock strong');
    return strong ? parseInt(strong.textContent.trim()) : null;
  };

  const updateButtons = () => {
    document.querySelectorAll('tr.variant-item').forEach(item => {
      const input = item.querySelector('input.quantity__input');
      const plus = item.querySelector('button[name="plus"]');
      const minus = item.querySelector('button[name="minus"]');
      const stockEl = item.querySelector('.variant-item__stock strong');
      if (!input || !plus || !stockEl) return;

      const max = parseInt(stockEl.textContent.trim());
      const val = parseInt(input.value) || 0;
      plus.disabled = val >= max;
      minus.disabled = val <= 0;

      // Création / suppression du message "Stock maximum atteint"
      let msg = item.querySelector('.stock-max-message');
      if (val >= max) {
        if (!msg) {
          msg = document.createElement('div');
          msg.className = 'stock-max-message';
          msg.textContent = 'Stock maximum atteint';
          msg.style.color = '#999';
          msg.style.fontSize = '12px';
          msg.style.marginTop = '4px';
          msg.style.textAlign = 'left';
          item.querySelector('.variant-item__quantity-wrapper')?.appendChild(msg);
        }
      } else if (msg) {
        msg.remove();
      }
    });
  };

  document.querySelectorAll('input.quantity__input').forEach(input => {
    input.addEventListener('input', updateButtons);
    input.addEventListener('change', updateButtons);
  });

  const observer = new MutationObserver(updateButtons);
  document.querySelectorAll('input.quantity__input').forEach(input => {
    observer.observe(input, { attributes: true, attributeFilter: ['value'] });
  });

  // Intercept fetch()
  const origFetch = window.fetch;
  window.fetch = async (...args) => {
    const [url, options] = args;
    if (url && typeof url === 'string' && url.includes('/cart/update')) {
      try {
        const formData = new URLSearchParams(options.body);
        const updates = formData.getAll('updates[]');
        const inputs = document.querySelectorAll('input.quantity__input');
        for (let i = 0; i < inputs.length; i++) {
          const input = inputs[i];
          const variantId = input.dataset.quantityVariantId;
          const max = getMaxForVariant(variantId);
          const val = parseInt(updates[i] || input.value) || 0;
          if (max && val > max) {
            input.value = max;
            updateButtons();
            return Promise.resolve(new Response(null, { status: 204 }));
          }
        }
      } catch (err) {
        console.error('Interception /cart/update error:', err);
      }
    }
    const res = await origFetch(...args);
    setTimeout(updateButtons, 200);
    return res;
  };

  // Intercept XMLHttpRequest (backup)
  const origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (...args) {
    this._url = args[1];
    return origOpen.apply(this, args);
  };
  const origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function (body) {
    if (this._url && this._url.includes('/cart/update')) {
      try {
        const params = new URLSearchParams(body);
        const updates = params.getAll('updates[]');
        const inputs = document.querySelectorAll('input.quantity__input');
        for (let i = 0; i < inputs.length; i++) {
          const input = inputs[i];
          const variantId = input.dataset.quantityVariantId;
          const max = getMaxForVariant(variantId);
          const val = parseInt(updates[i] || input.value) || 0;
          if (max && val > max) {
            input.value = max;
            updateButtons();
            return;
          }
        }
      } catch (err) {
        console.error('XHR interception error:', err);
      }
    }
    const res = origSend.call(this, body);
    setTimeout(updateButtons, 200);
    return res;
  };

  updateButtons();
});
